import { render } from "./knowledge-base-category-modal.vue?vue&type=template&id=63d48f0a"
import script from "./knowledge-base-category-modal.vue?vue&type=script&lang=js"
export * from "./knowledge-base-category-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__